import { FAQProps } from "_components/FAQs/FAQs";
import React, { PropsWithChildren } from "react";
import { Button, Icon } from "@chakra-ui/react";
import { FaArrowRight } from "react-icons/fa";
import { useHistory } from "react-router";
import { FAQsV2 } from "_components/FAQs";

export default function ClientsFAQs({
  items,
  onReadAllFAQs,
}: PropsWithChildren<FAQProps>) {
  const navigate = useHistory().push;

  return (
    <>
      <section className="grid grid-cols-1 lg:grid-cols-2 gap-6 px-3 lg:px-20 py-8 lg:py-16 border-[#121212] border-b-[1px]">
        <div className="text-center lg:text-left flex justify-center lg:justify-start items-center lg:items-start">
          <h3 className="w-[70%] lg:w-[75%] font-medium text-xl lg:text-5xl">
            {`We answered questions so you don't have to`}
            <br className="hidden lg:block" />
            ask them.
          </h3>
        </div>
        <div className="flex flex-col gap-6">
          <FAQsV2 items={items} />
          <Button
            backgroundColor={"#FEFEFE"}
            color={"#040A0D"}
            paddingY={{
              base: 6,
              lg: 10,
            }}
            borderColor={"#153243"}
            borderWidth={1}
            paddingX={{
              base: 8,
              lg: 10,
            }}
            fontSize={{
              base: 15,
              lg: 22,
            }}
            onClick={onReadAllFAQs ? onReadAllFAQs : () => navigate("/faqs")}
            rightIcon={
              <Icon
                as={FaArrowRight}
                w={{
                  base: 4,
                  lg: 6,
                }}
                h={{
                  base: 4,
                  lg: 5,
                }}
                ml={1}
              />
            }
          >
            Read all FAQs
          </Button>
        </div>
      </section>
    </>
  );
}


